"use strict";

exports.__esModule = true;
exports.dialogTitlePropTypes = exports.dialogHeaderPropTypes = exports.dialogFooterPropTypes = exports.dialogBodyPropTypes = exports.dialogActionsPropTypes = exports.dialogPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var variant = (0, _propTypes.oneOf)(Object.keys(_constants.VARIANT));
var dialogPropTypes = {
  actions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    text: _propTypes.string.isRequired,
    size: (0, _propTypes.oneOf)(Object.keys(_constants.ACTIONS_SIZE))
  })),
  appSelector: _propTypes.string,
  'aria-label': _propTypes.string,
  children: _propTypes.node,
  closeButtonLabel: _propTypes.string,
  closeOnEscape: _propTypes.bool,
  closeOnClickOutside: _propTypes.bool,
  disableFocusOnOpen: _propTypes.bool,
  disableFocusTrap: _propTypes.bool,
  hideOverlay: _propTypes.bool,
  id: _propTypes.string,
  isOpen: _propTypes.bool,
  modeless: _propTypes.bool,
  onClose: _propTypes.func,
  onOpen: _propTypes.func,
  preventCloseButtonClose: _propTypes.bool,
  showCloseButton: _propTypes.bool,
  size: (0, _propTypes.oneOf)(Object.keys(_constants.SIZE)),
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  usePortal: _propTypes.bool,
  variant: variant
};
exports.dialogPropTypes = dialogPropTypes;
var dialogActionsPropTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.element, (0, _propTypes.arrayOf)(_propTypes.element)]),
  variant: variant
};
exports.dialogActionsPropTypes = dialogActionsPropTypes;
var dialogBodyPropTypes = {
  children: _propTypes.node
};
exports.dialogBodyPropTypes = dialogBodyPropTypes;
var dialogFooterPropTypes = {
  children: _propTypes.node
};
exports.dialogFooterPropTypes = dialogFooterPropTypes;
var dialogHeaderPropTypes = {
  children: _propTypes.node,
  closeButton: _propTypes.node
};
exports.dialogHeaderPropTypes = dialogHeaderPropTypes;
var dialogTitlePropTypes = {
  appearance: (0, _propTypes.oneOf)(Object.keys(_constants.APPEARANCE)),
  as: (0, _propTypes.oneOf)(Object.keys(_constants.ELEMENT)),
  children: _propTypes.node.isRequired,
  id: _propTypes.string,
  variant: variant
};
exports.dialogTitlePropTypes = dialogTitlePropTypes;